import React from "react";
import "./SectionFour.css";

function SectionFour() {
  return (
    <div className="sectionFour">
      <a href="blank"> © Aston Martin 2022 </a>
    </div>
  );
}

export default SectionFour;
